export default __webpack_public_path__ + "static/3-5385a0f7e851537146e7a454a377f68f.jpg";